import {Component, DoCheck, Input} from '@angular/core';
import {ApplicationService} from '../../services/application.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-tab-task-receipt',
  templateUrl: './tab-task-receipt.component.html',
  styles: [
  ]
})
export class TabTaskReceiptComponent extends ExcTranslation implements DoCheck {
  @Input()
  ConfigReceiptTable: any;
  @Input()
  SummaryReceiptTable: any;
  @Input()
  tableDrawerIsLoading: any | undefined;
  @Input()
  Events: ExgEventArgs | any;

  private lastReceiptSortState = '';

  localConfig = {
    refreshLoading: (): void => {
      if (this.tableDrawerIsLoading) {
        this.tableDrawerIsLoading.next(false);
      }
    },

    openReceiptCheckview: (rcptID: any): void => {
      if (rcptID && this.excSecurity.isFeatured('RECEIPTREAD')) {
        this.appSvc.Receipt.Checkview.OpenTab(
          rcptID
        );
      }
    },

    openStatementCheckview: (rcptID: any): void => {
      if (rcptID && this.excSecurity.isFeatured('STATEMENTREAD')) {
        this.appSvc.Receipt.StatementCheckview.OpenTab(
          rcptID
        );
      }
    },
  };

  constructor(
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService
  ) {
    super();
  }

  ngDoCheck(): void {
    const currentState = this.getReceiptSortState();

    if (currentState !== this.lastReceiptSortState) {
      this.lastReceiptSortState = currentState;
      this.sortReceiptGroups();
    }
  }

  private getReceiptSortState(): string {
    if (!this.SummaryReceiptTable?.data || !Array.isArray(this.SummaryReceiptTable.data)) {
      return '';
    }

    return this.SummaryReceiptTable.data
      .map((group: any) =>
        `${group?.refGroupHeadline ?? ''}|${group?.receipts?.length ?? 0}|${
          Array.isArray(group?.receipts)
            ? group.receipts.map((receipt: any) => receipt?.rcptID ?? '').join(',')
            : ''
        }`
      )
      .join('||');
  }

  private sortReceiptGroups(): void {
    if (!this.SummaryReceiptTable?.data || !Array.isArray(this.SummaryReceiptTable.data)) {
      return;
    }

    for (const group of this.SummaryReceiptTable.data) {
      if (group?.receipts && Array.isArray(group.receipts)) {
        group.receipts.sort((a: any, b: any) => {
          const aDate = a?.rcptLCD ?? 0;
          const bDate = b?.rcptLCD ?? 0;
          return bDate - aDate;
        });
      }
    }
  }

  getObjectString(receiptData: any): string {
    let rtValue = '';
    if (receiptData.rcptObject && receiptData.rcptObject.length > 0) {
      const rcptObjects = JSON.parse(receiptData.rcptObject);
      for (const objElement of rcptObjects) {
        rtValue += objElement.enmText + '; ';
      }
    }

    return rtValue;
  }

  getReviewReasonsText(reviewReasonsJson: string): string {
    if (!reviewReasonsJson) { return ''; }
    try{
      const reasons = JSON.parse(reviewReasonsJson);
      return Array.isArray(reasons) ? reasons.filter(reason => reason.enmValue === true).map(reason => reason.enmText).join(', ') : '';
    } catch
    {
      return '';
    }
  }

  stripHtmlTags(value: string): string {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.body.textContent || '';
  }
}
